import React from "react";
import InnerPageLayout, { InnerPageHeader } from '../layouts/innerPage'
import {useFetchSuchanas} from "../features/suchanas/hooks/useFetchSuchanas";
import CircularLoader from "../components/CircularLoader";
import {useNavigate} from "react-router-dom";

const Contact = () => {
  const navigate = useNavigate();
  const { data, isLoading } = useFetchSuchanas()

  return (
    <InnerPageLayout
      innerPageHeader={null}
      innerPageSideBar={null}
      innerPageRightBar={null}
      innerPageContent={
        <div className='h-full flex-grow flex flex-col'>
          <div className="flex-grow w-full relative">
            <div className="absolute top-0 left-0 w-full h-full overflow-auto mask-overflow no-scrollbar bg-[#fff]">
              <div className="flex-grow relative w-full">
                {
                  isLoading
                    ? <CircularLoader/>
                    : data.length === 0
                      ? <></>
                      : (
                        <div className="top-0 left-0 w-full h-full flex flex-col gap-2 overflow-auto no-scrollbar">
                          <p></p>
                        </div>
                      )
                }
              </div>
            </div>
          </div>
        </div>
      }
    />
  )
}

export default Contact;
